export default {
    "export": {
        "library_folder": {
            "class": "app\\build\\level\\exportImport\\services\\FolderExportService",
            "permissions": []
        },
        "card": {
            "class": "app\\build\\level\\exportImport\\services\\CardExportService",
            "permissions": []
        }
    },
    "import": {
        "users": {
            "class": "app\\build\\level\\exportImport\\services\\UsersImportService",
            "permissions": [],
            "example": "UsersImport.xlsx"
        },
        "cards": {
            "class": "app\\build\\level\\exportImport\\services\\CardsImportService",
            "permissions": []
        }
    }
}